(function () {
    'use strict';

    angular.module('app').directive('habilCurrencyInput', CurrencyInputDirective);

    function CurrencyInputDirective() {
        return {
            require: { ngModelCtrl: '^ngModel', },
            template: `
                <input class="form-control"
                   ng-model="ngModel"
                   ng-model-options="{ updateOn: 'default' }"
                   name="{{name}}"
                   id="{{name}}"
                   type="number"
                   min="0"
                   maxlength="19"
                   required>
                `,
            scope: { name: '@', },
            link: link,
        };
    }

    function link(scope, _element, _attributes, controllers) {
        const ngModelCtrl = controllers.ngModelCtrl;

        ngModelCtrl.$render = () => scope.ngModel = ngModelCtrl.$viewValue;
        scope.$watch(function () { return scope.ngModel; }, function (value) {
            ngModelCtrl.$setViewValue(value);
        });
    }
})();